import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {ApiMarketplaceService} from "../../../../api/external/api-services/api-marketplace/api-marketplace.service";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {EMarketplaceActions, LoadSubscriptions, LoadSubscriptionsFailure, LoadSubscriptionsSuccess} from "../../actions/marketplace/marketplace.actions";
import {catchError, map, switchMap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";
import {SetDatasourcePartyId} from "../../actions/application-parameters/application-parameters.actions";
import {IRdfServiceResponseError} from "../../../../services/external-api/response-interfaces";

@Injectable()
export class MarketplaceEffects {
  Subscriptions$ = createEffect(() => this._actions$.pipe(
    ofType<LoadSubscriptions>(EMarketplaceActions.LoadSubscriptions),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
      return this._apiMarketplaceService.getSubscriptions()
        .pipe(
          map(
            result => {
              const tmp = storeState;
              return new LoadSubscriptionsSuccess(result);
            }
          ),
          catchError((error: IRdfServiceResponseError) => {
            console.error('MarketplaceEffects error');
            console.error(error);
            return of(new LoadSubscriptionsFailure());
            }
          )
        );
    })
  ));

  LoadSubscriptionsSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<LoadSubscriptionsSuccess>(EMarketplaceActions.LoadSubscriptionsSuccess),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        if (
          (<IAppState>storeState).marketplace.isLoaded &&
          (<IAppState>storeState).marketplace.datasourceProviders &&
          (<IAppState>storeState).marketplace.datasourceProviders.length
        ) {
          const currentPartyId = (<IAppState>storeState).authenticatedUser.data.selectedPartyId;
          const provider = currentPartyId === '0'?
            (<IAppState>storeState).marketplace.datasourceProviders.find(t => t.id === '0'):
            (<IAppState>storeState).marketplace.datasourceProviders.find(t => t.id !== '0');

          if (provider) {
            return of(new SetDatasourcePartyId(provider.id));
          } else {
            return of(new SetDatasourcePartyId(storeState.authenticatedUser.data.selectedPartyId));

          }


        } else {
          return of(new SetDatasourcePartyId(storeState.authenticatedUser.data.selectedPartyId));
        }


      }
    )
  ));
  LoadSubscriptionsFailure$ = createEffect(() => this._actions$.pipe(
    ofType<LoadSubscriptionsFailure>(EMarketplaceActions.LoadSubscriptionsFailure),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        return of(new SetDatasourcePartyId(storeState.authenticatedUser.data.selectedPartyId));
      }
    )
  ));


  constructor(
    private _apiMarketplaceService: ApiMarketplaceService,
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {
  }
}
